'use client';

import { useEffect, useRef, useState } from 'react';

import { styles } from './UiModSliderFading.styles';

export interface UiModSliderFadingProps {
  /** CSS-класс для основного контейнера */
  className?: string;
  /** Контент для отображения */
  children?: React.ReactNode;
  /** CSS-класс для внутренних контейнеров с контентом */
  containerClassName?: string;
}

/**
 * Компонент создает эффект проявления контента при переполнении родительского контейнера.
 * При превышении ширины создает дубликат контента с эффектом градиента.
 */
export function UiModSliderFading({
  children,
  className,
  containerClassName
}: UiModSliderFadingProps) {
  const ref = useRef<HTMLDivElement>(null);
  const [isActive, setIsActive] = useState(false);

  const slots = styles({ active: isActive });

  const checkActive = () => {
    setIsActive(
      Number(ref.current?.clientWidth) >
        Number(ref.current?.parentElement?.clientWidth)
    );
  };

  useEffect(() => {
    checkActive();
    let timer: number;
    const handleResize = () => {
      clearTimeout(timer);
      timer = window.setTimeout(() => {
        checkActive();
      }, 300);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      clearTimeout(timer);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className={slots.base({ className })}>
      <div
        ref={ref}
        className={slots.first({
          className: containerClassName
        })}
      >
        {children}
      </div>
      {isActive && (
        <div
          className={slots.second({
            className: containerClassName
          })}
        >
          {children}
        </div>
      )}
    </div>
  );
}
